module.exports = __webpack_public_path__ + "img/girl-torso-front.ca39ac7d.png";